import { Routes } from '@angular/router';
import { sessionGuard } from './core/guards/session.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/signin/authorize',
    pathMatch: 'full',
  },
  {
    path: 'signin/authorize',
    title: 'Autorizando...',
    loadComponent: () =>
      import('./features/signin-authorize/signin-authorize.component').then(
        (m) => m.SigninAuthorizeComponent,
      ),
  },
  {
    path: 'signin',
    loadComponent: () =>
      import('./features/auth/auth.component').then((m) => m.AuthComponent),
    canActivate: [sessionGuard],
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'login',
        title: 'Inicio de sesión',
        loadComponent: () =>
          import('./features/auth-login/auth-login.component').then((m) => m.AuthLoginComponent),
        data: { subtitle: 'Inicio de sesión' },
      },
      {
        path: 'mfa',
        title: 'Verificación de identidad',
        loadComponent: () =>
          import('./features/auth-mfa/auth-mfa.component').then((m) => m.AuthMfaComponent),
        data: { subtitle: 'Selección de método de verificación' },
      },
      {
        path: 'recovery-account',
        title: 'Recupero de contraseña',
        loadComponent: () =>
          import('./features/recovery-account/recovery-account.component').then(
            (m) => m.RecoveryAccountComponent,
          ),
        data: { subtitle: 'Recupero de contraseña' },
      },
      {
        path: 'recovery-otp',
        title: 'Verificación de identidad',
        loadComponent: () =>
          import('./features/recovery-otp/recovery-otp.component').then(
            (m) => m.RecoveryOtpComponent,
          ),
        data: { subtitle: 'Recupero de contraseña' },
      },
      {
        path: 'recovery-reset',
        title: 'Restablecer contraseña',
        loadComponent: () =>
          import('./features/recovery-reset/recovery-reset.component').then(
            (m) => m.RecoveryResetComponent,
          ),
        data: { subtitle: 'Recupero de contraseña' },
      },
    ],
  },
  {
    path: 'help',
    loadComponent: () =>
      import('./features/help/help.component').then((m) => m.HelpComponent),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./features/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent,
      ),
  },
  {
    path: '404',
    loadComponent: () =>
      import('./features/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
  {
    path: 'loading',
    loadComponent: () =>
      import('./features/loading/loading.component').then((m) => m.LoadingComponent),
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];
